import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  EVPaper, EVList, EVListItem, EVClickAwayListener,
  EVDivider, EVListSubheader, EVClear, EVListItemSecondaryAction,
  EVIconButton,
} from '@eagleview/ev-comp-library';
import { connect, useDispatch } from 'react-redux';
import { getMessages, markMsgArchive } from './Notifications.action';
import useStyles from './NotificationsPopupStyles';

const NotificationPopup = (props) => {
  const {
    handleClickAway,
    notifications,
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const getMsgs = (payload) => dispatch(getMessages(payload));
  const handleArchiveClick = (payload) => dispatch(markMsgArchive(payload));
  useEffect(() => {
    getMsgs({ userId: 'manish.j@ev.com' });
  }, []);

  return (
    <EVClickAwayListener onClickAway={handleClickAway}>
      <EVPaper className={classes.paper} elevation={6}>
        <EVList subheader={<EVListSubheader className={classes.listSubHdr}>NOTIFICATIONS (last 7 days)</EVListSubheader>}>
          {notifications.map((notification) => (
            <div>
              { !notification.archived && (
                <div key={notification.id}>
                  <EVListItem>
                    <div dangerouslySetInnerHTML={{ __html: notification.templateContent }} />
                    <EVListItemSecondaryAction>
                      <EVIconButton
                        edge="end"
                        aria-label="clear"
                        onClick={() => handleArchiveClick({ notificationId: notification.id })}
                      >
                        <EVClear />
                      </EVIconButton>
                    </EVListItemSecondaryAction>
                  </EVListItem>
                  <EVDivider />
                </div>
              )}
            </div>
          ))}
        </EVList>
      </EVPaper>
    </EVClickAwayListener>
  );
};

/**
 * selects required data from redux store
 * @param {Object} state - redux store object
 */
const selector = (state) => ({
  notifications: state.Notifications.notifications,
});

NotificationPopup.propTypes = {
  handleClickAway: PropTypes.func,
  notifications: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    userId: PropTypes.string,
    organizationId: PropTypes.string,
    eventId: PropTypes.string,
    templateContent: PropTypes.string,
    read: PropTypes.bool,
    archived: PropTypes.bool,
    eventData: PropTypes.shape(),
    meta: PropTypes.shape(),
  })),
};

NotificationPopup.defaultProps = {
  handleClickAway: () => {},
  notifications: [],
};

export { NotificationPopup };
export default connect(selector, {})(NotificationPopup);
